/**
 * Klinik personelinin görünen adı: rol adı (klinik rol şablonu) + unvan + ad soyad.
 * Rol, kişinin klinikteki rol şablonundan gelir ("Yönetici", "Diyetisyen" …);
 * sabit "Dr." ön eki kullanılmaz — her personel doktor değildir.
 */

/** Rol şablonu adı; kullanıcı nesnesi ya da randevu snapshot'ı kabul eder. */
export const staffRoleName = (u) => {
  const name = u?.roleTemplate?.name ?? u?.doctorRoleName ?? u?.roleName;
  const trimmed = typeof name === "string" ? name.trim() : "";
  return trimmed || null;
};

/** Unvan + ad soyad (rol hariç). */
export const staffFullName = (u) =>
  [u?.title, u?.name, u?.surname]
    .map((p) => (typeof p === "string" ? p.trim() : ""))
    .filter(Boolean)
    .join(" ");

/** Rol + unvan + ad soyad, tek satır metin (ör. "Yönetici Osman Aydın"). */
export const staffLabel = (u) =>
  [staffRoleName(u), staffFullName(u)].filter(Boolean).join(" ");
